import { render, staticRenderFns } from "./registrationDialog.vue?vue&type=template&id=24815441&scoped=true&"
import script from "./registrationDialog.vue?vue&type=script&lang=js&"
export * from "./registrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./registrationDialog.vue?vue&type=style&index=0&id=24815441&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24815441",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24815441')) {
      api.createRecord('24815441', component.options)
    } else {
      api.reload('24815441', component.options)
    }
    module.hot.accept("./registrationDialog.vue?vue&type=template&id=24815441&scoped=true&", function () {
      api.rerender('24815441', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/mawb/registrationDialog.vue"
export default component.exports